// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Reset = createIcon(
  <path
    clipRule="evenodd"
    d="M5.77854 10.4417C6.13001 10.7932 6.69986 10.7932 7.05133 10.4417C7.4028 10.0902 7.40279 9.52037 7.05132 9.1689L6.13653 8.25413H14.1648C16.8904 8.25413 19.0999 10.4636 19.0999 13.1892C19.0999 15.9148 16.8904 18.1243 14.1648 18.1243H6.41481C5.91776 18.1243 5.51481 18.5272 5.51481 19.0243C5.51481 19.5213 5.91776 19.9243 6.41481 19.9243H14.1648C17.8845 19.9243 20.8999 16.9089 20.8999 13.1892C20.8999 9.46953 17.8845 6.45413 14.1648 6.45413H6.20927L7.05132 5.61208C7.4028 5.26061 7.4028 4.69076 7.05132 4.33929C6.69985 3.98782 6.13 3.98782 5.77853 4.33929L3.3637 6.75412C3.19492 6.9229 3.1001 7.15182 3.1001 7.39052C3.1001 7.62921 3.19492 7.85813 3.36371 8.02692L5.77854 10.4417Z"
    fillRule="evenodd"
  />,
);
